/**
 * Composable for managing automations in Planning components
 */
import { onBeforeUnmount } from 'vue';
import useUsersAccessRightStore from '@/stores/users/accessRight';
import automationRulesEngine from './automationRulesEngine';

const availableCustomAutomations = {
  'cmsea-checklists': () => import('@/client_customs/CMSEA/LaneChecklistsPercentAutomation'),
};

export default function useAutomations() {
  const usersAccessRightStore = useUsersAccessRightStore();
  const customAutomationsInstances = new Map();

  onBeforeUnmount(() => {
    customAutomationsInstances.forEach(instance => instance.disable());
    automationRulesEngine.disable();
  });

  return {
    initAutomations(planning) {
      const { automations } = usersAccessRightStore.config;
      if (! automations?.length) return;

      if (automations.some(automation => automation.on)) automationRulesEngine.enable(planning); // activate automations rules engine

      const customAutomations = automations.filter(automation => typeof automation == 'string');
      customAutomations.forEach(async (automationId) => {
        const automationsModule = await availableCustomAutomations[automationId]?.();
        const Automations = automationsModule?.default || automationsModule;
        if (! Automations) { console.error(`Automation module for ${automationId} not found.`); return; }

        const customAutomationsInstance = new Automations();
        customAutomationsInstances.set(automationId, customAutomationsInstance);
        customAutomationsInstance.enable(planning);
      });
    },
  };
}
